import {
  getSpecCombinationListFromVariants,
  getSpecListFromConfigurableOptions,
} from '@/lib/sku-algorithm/lib/get-instock-value-indexes';
import SpecAdjoinMatrix from '@/lib/sku-algorithm/utils/spec-adjoin-martix';
import { isProductConfigurable } from '@/util/isProductConfigurable';
import { useState } from 'react';
import { getSortedColor } from './get-sorted-color';

export const useOptionsSpecs = ({ product }: { product: any }) => {
  const isConfigurable = isProductConfigurable(product);
  const specList = isConfigurable ? getSpecListFromConfigurableOptions(product?.configurable_options) : [];
  const specCombinationList = isConfigurable ? getSpecCombinationListFromVariants(product?.variants) : [];

  // const colorOptions = product?.configurable_options?.filter((item: any) => item?.label === "Color" && Array.isArray(item?.values) && item.values.length > 0);

  // configurableOptions 排序
  const sortedConfigurableOptions = product.configurable_options?.sort((a: any, b: any) => a.position - b.position);

  const sortedColor = getSortedColor({
    values: sortedConfigurableOptions?.find((item: any) => item.attribute_code === 'lw_color')?.values as any,
    variants: product.variants,
    attribute_code: 'lw_color',
  });

  const colorIndex = sortedConfigurableOptions?.findIndex((item: any) => item.attribute_code === 'lw_color');

  const [specsS, setSpecsS] = useState(() => {
    const myList = Array(specList.length).fill('');

    myList[colorIndex] = sortedColor?.[0]?.value_index?.toString() ?? '';

    return myList;
  });

  // 创建一个规格矩阵
  const specAdjoinMatrix = new SpecAdjoinMatrix(specList, specCombinationList);
  // 获得可选项表
  const optionSpecs = isConfigurable ? specAdjoinMatrix.getSpecscOptions(specsS) : [];

  const handleClick = function ({ bool, text, index }: { bool: boolean; text: string; index: number }) {
    // 排除可选规格里面没有的规格
    if (specsS[index] !== text && !bool) {
      return;
    }

    // 根据text判断是否已经被选中了
    specsS[index] = specsS[index] === text ? '' : text;
    setSpecsS(specsS.slice());
  };

  return {
    specsS, // 当前选中的顶点
    setSpecsS,
    specList,
    specCombinationList,
    optionSpecs, // 还可选中的顶点
    handleClick,
  };
};
